import { Coins } from "lucide-react";

interface TokenBalanceProps {
  balance: number;
}

export function TokenBalance({ balance }: TokenBalanceProps) {
  const formattedBalance = balance.toLocaleString("ru-RU");

  return (
    <div className="flex items-center gap-2 rounded-full bg-muted px-3 py-1.5 md:px-4 md:py-2">
      <Coins className="h-4 w-4 text-violet-600 md:h-5 md:w-5" />
      <span className="text-sm font-semibold text-foreground md:text-base">
        {formattedBalance}
      </span>
    </div>
  );
}
